import { sideEffect } from "./side-effect";
export const trace = (prefix = "") => sideEffect((x) => console.log(prefix, x));
